/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "CybersourcePaymentPageService";
const log: any = LoggerModule.getInstance();

export class CybersourcePaymentPageService {
  private static instance: CybersourcePaymentPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): CybersourcePaymentPageService {
    if (!CybersourcePaymentPageService.instance) {
      CybersourcePaymentPageService.instance =
        new CybersourcePaymentPageService(props);
    }
    return CybersourcePaymentPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    return content;
  }
  public async createTransaction(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    console.log(args);
    compProps = await agent.createTransaction(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }
  public async cybersourceSetupPayerAuth(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    console.log(args);

    compProps = await agent.cybersourceSetupPayerAuth(args);

    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async cybersourceComplete3ds(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    console.log(args);

    compProps = await agent.cybersourceComplete3ds(args);

    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
}
